const RapsoMobileTab = () =>
  import(
    /* webpackChunkName: "RapsoMobileTab" */ `@/components/rapsotec/projects/project/AIPortal/RapsoMobileTab.vue`
  );

const TopicAnalysisPlans = () =>
  import(
    /* webpackChunkName: "TopicAnalysisPlans" */ `@/components/rapsotec/projects/project/AIPortal/analyze/TopicAnalysisPlans.vue`
  );

const PlanAnalysisRequests = () =>
  import(
    /* webpackChunkName: "PlanAnalysisRequests" */ `@/components/rapsotec/projects/project/AIPortal/analyze/PlanAnalysisRequests.vue`
  );

export default [
  {
    path: "",
    redirect: { name: "pmrTopicAnalysisPlans" },
  },
  // PMR routes
  {
    path: "pmr/analyse",
    name: "pmrTopicAnalysisPlans",
    component: TopicAnalysisPlans,
    props: { analysisType: "PMR" },
  },
  {
    path: "pmr/historique-requetes",
    name: "pmrPlanAnalysisRequests",
    component: PlanAnalysisRequests,
    props: { analysisType: "PMR" },
  },
  // SI routes
  {
    path: "sh/analyse",
    name: "shTopicAnalysisPlans",
    component: TopicAnalysisPlans,
    props: { analysisType: "SI" },
  },
  {
    path: "sh/historique-requetes",
    name: "shPlanAnalysisRequests",
    component: PlanAnalysisRequests,
    props: { analysisType: "SI" },
  },
  {
    path: "rapso-mobile",
    name: "aiPortalRapsoMobile",
    component: RapsoMobileTab,
  },
];
